'use strict';

import {
    thirdPartyTracking,
    initTrackingAgent,
} from '@edreamsodigeo/frontend-tracking-agent';
import {createStorageClient} from '@edreamsodigeo/frontend-cmp-client';

export default Odigeo.Model.extend({
    dataURL: 'datalayer',

    pageNamesMap: {
        'general': 'general',
        'home': 'homepage',
        'prime/deals': 'inspirational-search',
    },
    _datalayerTrackingClient: null,

    url: function() {
        return Odigeo.Settings.getProperty('tagManagementUrlFormatter')(
            this.dataURL + '/' + this.getPageName()
        );
    },

    getPageName: function() {
        var pageName = Odigeo.Utils.isWebmasterPage()
            ? 'general'
            : (location.pathname.indexOf('/deals') > -1 ? 'prime/deals' : Odigeo.History.getPageNameFromFragment());
        return _.get(this.pageNamesMap, pageName) || 'homepage';
    },

    initialize: function() {
        const configParametersTrackingAgent = {
            generic: {
                visitID: Odigeo.SessionScope.visitId,
                storageClient: createStorageClient(
                    Odigeo.SessionScope.brand,
                    Odigeo.SessionScope.locale
                ),
                isNativeInterface:
                    Odigeo.SessionScope.isNativeInterface,
                dapiSessionId: Odigeo.SessionScope.dapiSessionId,
                locale: Odigeo.SessionScope.locale,
                flow: Odigeo.SessionScope.flow,
                device: Odigeo.Device.navigator.isIOSWebView
                    ? 'IOS_'
                    : 'ANDROID_',
                brand: Odigeo.SessionScope.brand,
                website: Odigeo.SessionScope.website,
                abs: [{
                    name: 'QUALTRICS_TMS',
                    value: Odigeo.AB.getQualtricsTms,
                }, {
                    name: 'TMS_RECOVERY',
                    value: Odigeo.AB.getTmsRecovery,
                }],
            },
            datamesh: {
                context: '/frontend-home',
            },
        };
        initTrackingAgent(configParametersTrackingAgent);

        this.loadTcVars();
        this.syncTcVars();
    },

    getDatalayerTrackingClient: function() {
        if (!this._datalayerTrackingClient) {
            const {createDatalayerTrackingClient} = thirdPartyTracking;
            this._datalayerTrackingClient = createDatalayerTrackingClient();
        }
        return this._datalayerTrackingClient;
    },

    syncTcVars: function() {
        const tcVars = this.flatten(this.toJSON());
        this.getDatalayerTrackingClient().save({
            ...tcVars,
            ...this.getClientSideAttributes(),
        });
    },

    loadTcVars: function() {
        const tcVars = _.cloneDeep(window.tc_vars) || {};
        for (var key in tcVars) {
            if (Object.prototype.hasOwnProperty.call(tcVars, key)) {
                this.set(key, tcVars[key]);
            }
        }
    },

    fireEvent: function(category, key, value) {
        this.getDatalayerTrackingClient().trackEvent({
            event_category: category,
            [key]: value,
        });
    },

    loadContainer: function() {
        const {trackTMSPage} = thirdPartyTracking;
        const tcVars = {
            ...this.flatten(this.toJSON()),
            ...this.getClientSideAttributes(),
        };
        trackTMSPage(tcVars, {skipFetch: true});
    },

    isPageInWhitelist: function() {
        return _.has(_.invert(this.pageNamesMap), this.getPageName());
    },

    updateDatalayer: function() {
        if (this.isPageInWhitelist()) {
            this.fetch({
                data: {product: Odigeo.Utils.getFunnelInGlobalScope()},
                success: this.loadContainer.bind(this),
            });
        }
    },

    getClientSideAttributes: function() {
        return {
            home_version: Odigeo.SessionScope.oneFrontHomeVersion,
            ...(Odigeo.Utils.isWebmasterPage() ? {page_category: 'wmp'} : {}),
        };
    },

    extendDatalayer: function(extendedData) {
        this.set(this.flatten(extendedData));
        this.syncTcVars();
    },

    flatten: (obj) => {
        const {flatten: flat} = thirdPartyTracking;
        return flat(obj);
    },
});
